import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useSubRoutes, useExactRedirect, usePermissionTabs } from 'hooks';
import { globalPropTypes } from 'helpers';
import { Tabs, Alerts } from 'components';
import CisHeader from '../../../components/CisHeader/CisHeader';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.ma.ipmaRegistration',
    url: '/ma/ipma-registration',
  },
  {
    title: 'navigation.breadcrumbs.ma.cpdManagement',
    url: '/ma/cpd-management',
  },
];

const initialTabs = [
  {
    title: 'navigation.tabs.ma.cpdManagement.trainings',
    path: '/ma/cpd-management/trainings',
    key: 'trainings',
  },
  {
    title: 'navigation.tabs.ma.cpdManagement.cpdDiplomas',
    path: '/ma/cpd-management/cpd-diplomas',
    key: 'cpdDiplomas',
  },
  {
    title: 'navigation.tabs.ma.cpdManagement.competencies',
    path: '/ma/cpd-management/competencies',
    key: 'competencies',
  },
  {
    title: 'navigation.tabs.ma.cpdManagement.courses',
    path: '/ma/cpd-management/courses',
    key: 'courses',
  },
];

const CpdManagement = ({ routes, userPermissions }) => {
  const { t } = useTranslation();

  const [renderSubRoutes] = useSubRoutes(routes);
  const [tabs, firstTabPath] = usePermissionTabs(initialTabs, routes, userPermissions);
  const [renderExactRedirect] = useExactRedirect('/ma/cpd-management', firstTabPath);

  return (
    <>
      <CisHeader
        breadcrumbs={breadcrumbs}
        title={t('page.ma.cpdManagement.title')}
        renderActions={() => <div id="cpd-mgmt-buttons-portal"></div>}
      />
      <Tabs disableCounter={true} items={tabs} />
      <Alerts type="cpd" />
      {renderExactRedirect()}
      {renderSubRoutes()}
    </>
  );
};

CpdManagement.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
  userPermissions: globalPropTypes.UserPermissions.isRequired,
};

CpdManagement.defaultProps = {
  routes: [],
};

const mapStateToProps = ({ user }) => ({
  userPermissions: user.userPermissions,
});

export default connect(mapStateToProps, null)(CpdManagement);
